import React, {Component, Fragment} from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';
import {AVAILABLE_TYPES_TREE} from '../../../constants';
import messages from '../../../../res/translations/messages';
import ItemTypePickerItem from './ItemTypePickerItem';
import Icon from '../../Icon';
import {find} from 'lodash';
import TooltipContainerUnformatted from '../../TooltipContainerUnformatted';
import {injectIntl} from 'react-intl';

class ItemTypePicker extends Component {
    constructor(props) {
        super(props);

        this.itemClicked = this.itemClicked.bind(this);
        this.branchClicked = this.branchClicked.bind(this);
        this.backClicked = this.backClicked.bind(this);
        this.toggle = this.toggle.bind(this);
        this.state = {
            open: false,
            branch: null,
        };
    }

    itemClicked(item) {
        const {type} = item;
        this.setState({open: false});
        this.props.onItemClicked(type);
    }

    branchClicked(item) {
        const {id} = item;
        this.setState({branch: id});
    }

    backClicked() {
        this.setState({branch: null});
    }

    toggle() {
        this.setState((prevState) => ({
            open: !prevState.open,
            branch: null,
        }));
    }

    render() {
        const {intl} = this.props;
        let currentType = null;
        let availableTypes = AVAILABLE_TYPES_TREE;
        if (this.state.branch !== null) {
            currentType = find(AVAILABLE_TYPES_TREE, (i) => i.id === this.state.branch);
            availableTypes = currentType.types;
        }
        return (
            <Fragment>
                <Button onClick={this.toggle} className="survey-editor-item add-item full-width mb20">
                    <Icon icon="add" /> <FormattedMessage {...messages.surveys.button.add_editor} />
                </Button>
                <Modal isOpen={this.state.open} toggle={this.toggle} size="md">
                    <ModalHeader toggle={this.toggle}>
                        <FormattedMessage {...messages.surveys.modals.addQuestion.title} />
                    </ModalHeader>
                    <ModalBody>
                        {this.state.branch === null ? (
                            <div className="item-type-picker">
                                {availableTypes.map(({id, name, icon, types}) => {
                                    const toolTipMessage = types.map((type) => intl.formatMessage(messages.types[type])).join(', ');
                                    return (
                                        <TooltipContainerUnformatted key={name} component="div" tooltip={toolTipMessage}>
                                            <ItemTypePickerItem id={id} name={name} type={icon} onClick={this.branchClicked} />
                                        </TooltipContainerUnformatted>
                                    );
                                })}
                            </div>
                        ) : (
                            <>
                                <a className="btn mr-2" id={null} onClick={this.backClicked}>
                                    <span className="icon icon-ic_back" />
                                    <FormattedMessage {...messages.type_groups.back} />
                                </a>
                                <span className="mr-4">/</span>
                                <span className="btn-outline-primary">
                                    <FormattedMessage {...messages.type_groups[currentType.name]} />
                                </span>
                                <div className="item-type-picker mt-4">
                                    {availableTypes.map((type) => {
                                        return <ItemTypePickerItem key={type} type={type} onClick={this.itemClicked} />;
                                    })}
                                </div>
                            </>
                        )}
                    </ModalBody>
                    <ModalFooter style={{justifyContent: 'center'}}>
                        <button type="button" className={classNames('btn btn-outline-secondary btn-sm')} onClick={this.toggle}>
                            <FormattedMessage {...messages.buttons.cancel} />
                        </button>
                    </ModalFooter>
                </Modal>
            </Fragment>
        );
    }
}

export default injectIntl(ItemTypePicker);
